import React from 'react';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import './ConsentModal.css';  

const ConsentModal = ({ showConsent, onHide }) => {
  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ zIndex: 10001, marginTop: '15px' }}
      show={showConsent}
      onHide={onHide}
    >
      <div className="modal-body styled-modal-body">
        <div className="p-3 consentModal-AutoHypenation">
          ALL OF YOUR INTERACTION WITH THIS SOFTWARE IS BEING RECORDED. By using
          this software/website/mobile app, you agree to the Sun West Mortgage
          Company, Inc. NMLS 3277 (&quot;Sun West&quot;) and Celligence
          International, LLC.&#39;s (&quot;Celligence&quot;){' '}
          <a
            className="form-link"
            href="https://angelai.com/terms-and-conditions"
            target="_blank"
            rel="noreferrer noopener"
          >
            Terms and Conditions
          </a>{' '}
          and{' '}
          <a
            className="form-link"
            href="https://www.celligence.com/privacy"
            target="_blank"
            rel="noreferrer noopener"
          >
            Security Policy
          </a>
          ; all of which you may access by clicking on the &quot;Terms and
          Conditions&quot; or &quot;Security Policy&quot; web links contained
          herein.
        </div>
        <div className="p-3 text-center">
          <Button
            className="consenModalNoBtn"
            variant="secondary"
            href="https://sunwestmortgage.myloaninfo.com/loanmanager/login/"
            target="_blank"
            rel="noopener"
            onClick={onHide}
          >
            No
          </Button>
          <Button
            className="consenModalYesBtn"
            variant="success"
            href="https://sunwestmortgage.myloaninfo.com/loanmanager/login/"
            target="_blank"
            rel="noopener"
            onClick={onHide}
          >
            Yes
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConsentModal;
